import { useGetList } from 'react-admin';

import type { UserCallRecordingConf } from '@ragu-components/ord-types';

interface UseUserRecordingConfsDataReturn {
  assignments: UserCallRecordingConf[];
  loaded: boolean;
}

export const useUserRecordingConfsData = (confId: string): UseUserRecordingConfsDataReturn => {
  const resource = `call_recording_confs/${confId}/user_call_recording_confs`;
  const { data: assignments } = useGetList<UserCallRecordingConf>(resource, {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'type', order: 'ASC' },
  });

  return {
    assignments: assignments ?? [],
    loaded: assignments !== undefined,
  };
};
